import { DataBean } from "../DataBean";

export class ContributorSubtype extends DataBean {



    public async getContributorSubtypeCatalog(args:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getContributorSubtypeCatalog_Number", [args]);
    }
     public async deleteContributorSubtype(idContributorSubtype:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteContributorSubtype_Number", [idContributorSubtype]);
    }
     public async updateContributorSubtype(bean:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "admin.ContributorSubtype_updateContributorSubtype_admin.ContributorSubtype", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "admin.ContributorSubtype"
            }
        ]);
    }
}